//Format date time to display
export const timeAgo = dateParam => {
  if (!dateParam) {
    return null;
  }

  const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
  const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
  const today = new Date();
  const yesterday = new Date(today - DAY_IN_MS);
  const seconds = Math.round((today - date) / 1000);
  const minutes = Math.round(seconds / 60);
  const isToday = today.toDateString() === date.toDateString();
  const isYesterday = yesterday.toDateString() === date.toDateString();
  const isThisYear = today.getFullYear() === date.getFullYear();

  if (seconds < 5) {
    return 'now';
  } else if (seconds < 60) {
    return `${seconds} seconds ago`;
  } else if (seconds < 90) {
    return 'about a minute ago';
  } else if (minutes < 60) {
    return `${minutes} minutes ago`;
  } else if (isToday) {
    return getFormattedDate(date, 'Today'); // 10:20AM
  } else if (isYesterday) {
    return getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20AM
  } else if (isThisYear) {
    return getFormattedDate(date, false, true); // Jan 10 at 10:20AM
  }

  return getFormattedDate(date); // Jan 10, 2017 at 10:20AM
};

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

const getFormattedDate = (date, prefomattedDate = false, hideYear = false) => {
  const day = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();

  // fetch
  let hours = date.getHours();
  let minutes = date.getMinutes();

  // calculate
  let timeValue;
  if (hours > 0 && hours <= 12) {
    timeValue = '' + hours;
  } else if (hours > 12) {
    timeValue = '' + (hours - 12);
  } else if (hours == 0) {
    timeValue = '12';
  }

  timeValue += minutes < 10 ? ':0' + minutes : ':' + minutes; // get minutes
  timeValue += hours >= 12 ? ' PM' : ' AM'; // get AM/PM

  if (prefomattedDate) {
    // 10:20AM
    if (prefomattedDate == 'Today') {
      return `${timeValue}`;
    }
    // Yesterday at 10:20AM
    return `${prefomattedDate} at ${timeValue}`;
  }

  if (hideYear) {
    // 10. January at 10:20
    return `${month} ${day} at ${timeValue}`;
  }

  // 10. January 2017. at 10:20
  return `${month} ${day}, ${year} at ${timeValue}`;
};
